{
    "account": "ⴰⵎⵉⴹⴰⵏ",
    "add_bookmark": "ⵔⵏⵓ ⴳ ⵜⵙⵏⴰ ⵏ ⵜⵎⵉⵜⴰⵔ",
    "add_date": "ⵔⵏⵓ ⴽⵔⴰ ⵏ ⵓⵙⴰⴽⵓⴷ",
    "ago": "{{duration}} ⵉⵣⵔⵉⵏ",
    "api_key": "ⵜⴰⵙⴰⵔⵓⵜ ⵏ API",
    "are_you_sure": "ⵉⵙ ⵜⵃⵇⵇⵉⴷ?",
    "ask_delete_message": "ⵉⵙ ⵜⵃⵇⵇⵉⴷ ⴰⴷ ⵜⴽⴽⵙⴷ ⵜⴰⴱⵔⴰⵜ ⴰⴷ?",
    "audio_not_ready": "",
    "bookmark_added": "ⵜⵓⴷⴼ ⵜⴱⵔⴰⵜ ⵖⵔ ⵜⵙⵏⴰ ⵏ ⵜⵎⵉⵜⴰⵔ !",
    "bookmark_removed": "ⵜⴻⵜⵜⵡⴰⴽⴽⵙ ⵜⴱⵔⴰⵜ ⵙⴳ ⵜⵙⵏⴰ ⵏ ⵜⵎⵉⵜⴰⵔ !",
    "bookmarks": "ⵜⴰⵙⵏⴰ ⵏ ⵜⵎⵉⵜⴰⵔ",
    "cancel_write": "ⵉⵙ ⵜⵃⵇⵇⵉⴷ ⵓⵔ ⵜⵔⵉⴷ ⴰⴷ ⵜⴰⵔⵉⴷ ⴽⵔⴰ ⵏ ⵜⴱⵔⴰⵜ ⵜⴰⵎⴰⵢⵏⵓⵜ?",
    "cancel": "ⵙⵙⵔ",
    "changed_group_name": "ⵜⵙⵏⴼⵍⴷ ⵉⵙⵎ ⵏ ⵜⴳⵔⵓⵎⵎⴰ",
    "confirm_password_placeholder": "ⵙⴷⴷⵉⴷ ⵉⵏⵉⴳⵍ ⵏ ⵡⴰⴷⴰⴼ",
    "connect": "ⴰⵡⴰⴹ",
    "create_a_group": "ⵙⴽⵔ ⴽⵔⴰ ⵏ ⵜⴳⵔⵓⵎⵎⴰ",
    "create_the_group": "ⵙⴽⵔ ⵜⴰⴳⵔⵓⵎⵎⴰ",
    "daily": "ⴽⵓ ⴰⵙⵙ",
    "default_group": "ⵜⴰⴳⵔⵓⵎⵎⴰ ⵜⴰⵎⵔⴷⵓⵜ",
    "delete": "ⵙⵙⴼⴹ",
    "destroy_account_explain": "ⵎⵛ ⵜⴽⴽⵙⴷ ⴰⵎⵉⴹⴰⵏ ⵏⵏⴽ, ⵓⵙⴰⵔ ⴰⴷ ⴷ ⵜⴰⵖⵓⵍⴷ. ⵃⵇⵇⴰ ⵙ ⵓⵢⴰⴷ.",
    "destroy_account": "ⴽⴽⵙ ⴰⵎⵉⴹⴰⵏ ⵏⵏⴽ",
    "edit": "ⵙⴳⴳⴷ",
    "email_input": "ⵙⵙⵉⴷⴼ ⵉⵎⴰⵢⵍ ⵏⵏⴽ ⴷⴰ",
    "email": "ⵉⵎⴰⵢⵍ",
    "empty_message": "ⵜⵅⵡⴰ ⵜⴱⵔⴰⵜ ⵓⵔ ⵉⵣⵔⵉ ⵓⵙⵉⴼⴹ ⵏⵏⵙ !",
    "error_new_message": "ⵜⴰⵣⴳⵍⵜ ⴳ ⵓⵙⵉⴼⴹ ⵏ ⵜⴱⵔⴰⵜ ⵏⵏⴽ.",
    "error_upload": "ⵜⴰⵣⴳⵍⵜ ⴳ ⵡⴰⴳⴰⵎ",
    "error": "ⵜⵍⵍⴰ ⵉⵛⵜ ⵏ ⵜⵣⴳⵍⵜ",
    "forgot_password": "ⵉⵙ ⵜⴻⵜⵜⵓⴷ ⵉⵏⵉⴳⵍ ⵏ ⵡⴰⴷⴰⴼ ⵏⵏⴽ?",
    "group_left": "ⵜⴼⴼⵖⴷ ⵙⴳ ⵜⴳⵔⵓⵎⵎⴰ !",
    "group_share_choice": "ⵎⴰⵜⵜⴰ ⵜⴳⵔⵓⵎⵎⴰ ⵏⵏⴰ ⵜⵔⵉⴷ ⴰⴷ ⴰⵙ ⵜⵙⵙⵉⴼⴹⴷ ⵜⴰⴱⵔⴰⵜ ⴰⴷ?",
    "groups": "ⵜⵉⴳⵔⵓⵎⵎⴰⵡⵉⵏ",
    "group_updated": "ⵜⴻⵜⵜⵓⵙⵎⴰⵢⵏⵓ ⵜⴳⵔⵓⵎⵎⴰ ⵏⵏⴽ !",
    "has_commented_on": "ⵉⵙⴽⵔ ⴰⵅⴼⴰⵡⴰⵍ ⵅⴼ",
    "has_joined": "ⵉⴽⵛⵎ",
    "has_left": "ⵉⴼⴼⵖ",
    "has_posted_in": "ⵉⵜⵜⵡⴰⴼⵙⵔ ⴳ",
    "hourly": "ⴽⵓ ⵜⴰⵙⵔⴰⴳⵜ",
    "Invalid login/password": "ⵉⵜⵜⴰⵡⵣⴳⵍ ⵓⴽⵛⴰⵎ ⴷ/ⵏⵉⵖ ⵉⵏⵉⴳⵍ ⵏ ⵡⴰⴷⴰⴼ",
    "invitation_link": "ⴰⵙⵖⵓⵏ ⵏ ⵓⵙⵉⴳⵔ",
    "invitation_welcome": "ⴰⵏⵙⵓⴼ ⵉⵙⴽ ⴳ Zusam ! ⵉⵅⵚⵚⴰ ⴰⴽ ⵓⵣⵎⵎⴻⵎ ⴷⴰⵜ ⵏ ⵓⴽⵛⴰⵎ ⵖⵔ ⵜⴳⵔⵓⵎⵎⴰ.",
    "in": "ⴳ",
    "just_now": "ⴷⵖⵉ ⵏⵏⵉⵜ",
    "lang": "ⵜⵓⵜⵍⴰⵢⵜ",
    "login_input": "ⵙⵜⵉ ⴽⵔⴰ ⵏ ⵓⴽⵛⴰⵎ",
    "login_placeholder": "ⵉⵎⴰⵢⵍ",
    "login": "ⴰⴽⵛⴰⵎ",
    "logout": "ⴼⴼⵖ",
    "mark_all_as_read": "ⵕⵛⵎ ⵎⴰⵕⵕⴰ ⴰⵎ ⵉⵜⵜⵡⴰⵖⵔⵏ",
    "monthly": "ⴽⵓ ⴰⵢⵢⵓⵔ",
    "multiple_photos_upload": "ⵜⴰⵣⴳⵍⵜ. ⴰⵍⵙ ⴰⴳⴰⵎ ⵏ ⵜⵡⵍⴰⴼⵉⵏ ⵉⵛⵜ ⵙ ⵢⵉⵛⵜ (ⵉⵣⵎⵔ ⴰⴷ ⵢⵉⵍⵉ ⵓⵢⴰⴷ ⴷⵉ ⴽⵔⴰ ⵏ ⵉⵎⵙⵙⴰⵔⴰⵜⵏ).",
    "name_input": "ⵙⵜⵉ ⴽⵔⴰ ⵏ ⵢⵉⵙⵎ",
    "name": "ⵉⵙⵎ",
    "new_password_placeholder": "ⵉⵏⵉⴳⵍ ⴰⵎⴰⵢⵏⵓ ⵏ ⵡⴰⴷⴰⴼ",
    "next_coms": "ⵥⵕ ⵉⵅⴼⴰⵡⴰⵍⵏ ⵉⵎⴳⴳⵓⵔⴰ",
    "none": "ⵓⵀⵓ",
    "notification_emails_stopped": "ⴱⴷⴷⵏ ⵉⵙⵓⴼⵔⵉⵜⵏ ⵏ ⵉⵎⴰⵢⵍ !",
    "notification_emails": "ⵉⵙⵓⴼⵔⵉⵜⵏ ⵏ ⵉⵎⴰⵢⵍ",
    "notifications": "ⵉⵙⵓⴼⵔⵉⵜⵏ",
    "parent_message": "ⵜⴰⴱⵔⴰⵜ ⵏ ⵉⵎⴰⵔⴰⵡⵏ",
    "password_input": "ⴰⵔⵉ ⴷⴰ ⵉⵏⵉⴳⵍ ⴰⵎⴰⵢⵏⵓ ⵏ ⵡⴰⴷⴰⴼ",
    "password_placeholder": "ⵉⵏⵉⴳⵍ ⵏ ⵡⴰⴷⴰⴼ",
    "password_reset_mail_sent": "ⵉⵜⵜⵡⴰⵙⵙⵉⴼⴹ ⵉⵎⴰⵢⵍ ⵅⴼ ⵡⴰⵍⴰⵙ ⵏ ⵓⵙⵔⵓⵙ ⵏ ⵉⵏⵉⴳⵍ ⵏ ⵡⴰⴷⴰⴼ!",
    "passwords_dont_match": "ⵓⵔ ⵉⵎⵙⴰⵙⴰ ⵉⵏⵉⴳⵍ ⵏ ⵡⴰⴷⴰⴼ",
    "password": "ⵉⵏⵉⴳⵍ ⵏ ⵡⴰⴷⴰⴼ",
    "previous_coms": "ⵥⵕ ⵉⵅⴼⴰⵡⴰⵍⵏ ⵉⵎⵣⵡⵓⵔⴰ",
    "public_link": "ⴰⵙⵖⵓⵏ ⴰⵎⴰⵜⴰⵢ",
    "publish_in_group": "ⴼⵙⵔ ⴳ ⵜⴳⵔⵓⵎⵎⴰ",
    "quit_group": "ⴼⴼⵖ ⵙⴳ ⵜⴳⵔⵓⵎⵎⴰ",
    "remove_bookmark": "ⴽⴽⵙ ⵜⴰⵙⵏⴰ ⵏ ⵜⵎⵉⵜⴰⵔ",
    "replies_one": "{{count}} ⵉⵔⴰⵔ",
    "replies_other": "{{count}} ⵜⵉⵎⵔⴰⵔⵓⵜⵉⵏ",
    "reply": "ⵔⴰⵔ",
    "reset_api_key": "ⵙⵏⴼⵍ ⵜⴰⵙⴰⵔⵓⵜ ⵏ API (ⵔⴰⴷ ⵉⵜⵜⵡⴰⴽⴽⵙ ⵓⵎⵢⴰⵡⴰⴹ ⵏⵏⴽ)",
    "reset_invitation_link": "ⴰⵍⵙ ⴰⵙⵏⵓⵎ ⵏ ⵓⵙⵖⵓⵏ ⵏ ⵓⵙⵉⴳⵔ",
    "reset_password_title": "ⴰⵍⵙ ⴰⵙⵏⵓⵎ ⵏ ⵉⵏⵉⴳⵍ ⵏ ⵡⴰⴷⴰⴼ ⵏⵏⴽ",
    "save_changes": "ⵃⴹⵓ ⵉⵙⵏⴼⴰⵍⵏ",
    "search_in_group": "ⵔⵣⵓ ⴳ ⵜⴳⵔⵓⵎⵎⴰ",
    "search_without_result": "ⵓⵔ ⵉⵎⵙⴰⵙⴰ ⵓⵔⵣⵓ ⵏⵏⴽ ⴰⴽⴷ ⴽⵔⴰⵢⴳⴰⵜⵜ ⵜⴰⴱⵔⴰⵜ.",
    "settings_updated": "ⵜⵜⵓⵙⵎⴰⵢⵏⵓⵏⵜ ⵜⵙⵖⴰⵍ ⵏⵏⴽ",
    "settings": "ⵜⵉⵙⵖⴰⵍ",
    "share_message": "ⴱⴹⵓ ⵜⴰⴱⵔⴰⵜ ⴰⴼ",
    "signup": "ⴰⵣⵎⵎⴻⵎ",
    "submit": "ⴰⵣⵏ",
    "text_placeholder": "ⴰⵔⵉ ⴷⴰ ⵜⴰⴱⵔⴰⵜ ⵏⵏⴽ",
    "the_message_from": "ⵜⴰⴱⵔⴰⵜ ⵙⴳ",
    "title_placeholder": "ⴰⵣⵡⵍ ⵏ ⵜⴱⵔⴰⵜ ⵏⵏⴽ (ⴰⵔⵓⵛⵛⵉⵍ)",
    "to": "ⵉ",
    "upload_audio": "",
    "upload_image": "ⵔⵏⵓ ⵜⵉⵡⵍⴰⴼⵉⵏ",
    "upload_music": "ⵔⵏⵓ ⵉⵥⴰⵡⴰⵏⵏ",
    "upload_pdf": "ⵔⵏⵓ PDF",
    "upload_video": "ⵔⵏⵓ ⵉⴼⵉⴷⵢⵓⵜⵏ",
    "User not found": "ⴰⵏⵙⵙⵎⵔⵙ ⵓⵔ ⵉⵍⵍⵉ",
    "users": "ⵉⵏⵙⵙⵎⵔⴰⵙ",
    "video_not_ready": "ⵉⵙⵓⵍ ⵓⵔ ⵉⵡⵊⵉⴷ ⵓⴼⵉⴷⵢⵓ.",
    "weekly": "ⴽⵓ ⵉⵎⴰⵍⴰⵙⵙ"
}
